import React from 'react';

class CountryProfileSubSectionCheckboxList extends React.PureComponent {
  renderList() {
    const list = this.props.list;

    if (!list) return null;

    return list.map((item, index) => {
      return (
        <li key={ index }>{ item }</li>
      );
    });
  }

  render() {
    const { content, className } = this.props;

    return (
      <div>
        <p className={ className }>
          { content }
        </p>
        <ul className={ className }>
          { this.renderList() }
        </ul>
      </div>
    );
  }
}

export default CountryProfileSubSectionCheckboxList;



// WEBPACK FOOTER //
// ./src/components/CountryProfile/CountryProfileSubSectionCheckboxList.js